var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-zip h-100"},[(_vm.running)?_c('div',{staticClass:"position-absolute h-100 w-100"},[_c('spinner')],1):_vm._e(),_c('zip-files')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }